import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";

import { apiPost, errorMessage, qk } from "@/shared/api";

/**
 * Сброс демо-счёта пользователя силами поддержки (доработки §7).
 *
 * Реальный баланс не затрагивается, поэтому `qk.user` инвалидируется только
 * ради журнала: сам сброс на карточке пользователя ничего не меняет. Ключ
 * `["audit"]` — обязателен: действие пишется в журнал администратора, и он
 * должен обновиться сразу.
 */
export function useResetDemo(userId: number) {
  const queryClient = useQueryClient();
  const { message } = App.useApp();

  return useMutation({
    mutationFn: () =>
      apiPost("/api/v1/admin/users/{user_id}/demo/reset", {
        params: { user_id: userId },
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: qk.user(userId) });
      void queryClient.invalidateQueries({ queryKey: ["audit"] });
    },
    onError: (error) => {
      void message.error(errorMessage(error));
    },
  });
}
